import React, { createContext, useContext, useState } from 'react';

// Create a context
const QuizFormContext = createContext({});

// Create a provider component
const QuizFormProvider = ({ children }) => {
  const [formValues, setFormValues] = useState([]);
  const [allFormErrorsList, setAllFormErrorsList] = useState({});
  const [allrenderFieldsName, setallrenderFieldsName] = useState([]);
  const [contentFullErrorMsg, setContentFulErrorMsg] = useState({});
  const [quizStepTwoErrors, setQuizStepTwoErrors] = useState([]);
  const [isLoggin, setIsLoggin] = useState(false);
  const [isFormValuesSaved, setIsFormValuesSaved] = useState(false)
  const [comitteeSectionToShow, setComitteeSectionToShow] = useState("");
  const [isCongratulationsModalOpen, setIsCongratulationsModalOpen] = useState(false);

  function getInputValues(inputName, formValuesArr) {
    if (formValuesArr) {
      const inputObject = formValuesArr.find((item) => {
        const key = Object.keys(item)[0];
        return key === inputName;
      });

      return inputObject ? inputObject[Object.keys(inputObject)[0]] : {};
    }
  }

  return (
    <QuizFormContext.Provider
      value={{
        formValues,
        setFormValues,
        allFormErrorsList,
        setAllFormErrorsList,
        allrenderFieldsName,
        setallrenderFieldsName,
        contentFullErrorMsg,
        setContentFulErrorMsg,
        getInputValues,
        quizStepTwoErrors,
        setQuizStepTwoErrors,
        isLoggin,
        setIsLoggin,
        isFormValuesSaved,
        setIsFormValuesSaved,
        comitteeSectionToShow,
        setComitteeSectionToShow,
        isCongratulationsModalOpen,
        setIsCongratulationsModalOpen,
      }}
    >
      <>{children}</>
    </QuizFormContext.Provider>
  );
};

// Create a custom hook to use the context
const useQuizFormContext = () => {
  const context = useContext(QuizFormContext);
  if (!context) {
    throw new Error('useQuizFormContext must be used within an QuizFormProvider');
  }
  return context;
};

export { QuizFormProvider, useQuizFormContext };
